import { useTranslation } from "react-i18next";
import ExpandableText from "../../../../components/app/ExpandableText";
import ScientificText from "../../../../components/ScientificText";
import type { ArticlePageArticle } from "../../hooks/useArticleData";
import { SectionTitle } from "../../../../components/ui/SectionTitle";

interface ArticleSectionConclusionProps {
  article: ArticlePageArticle;
  isExpanded: boolean;
  setExpand: (isExpanded: boolean) => void;
}

export function ArticleSectionConclusion({
  article,
  isExpanded,
  setExpand,
}: ArticleSectionConclusionProps) {
  const { t } = useTranslation();
  const conclusion = article.conclusion.filter((el) => el !== "");

  if (conclusion.length === 0) return null;

  return (
    <section data-gtm-section="conclusion" data-gtm-order="1">
      <SectionTitle title={t("Conclusion")} className="mb-4" />
      <ExpandableText
        isExpanded={isExpanded}
        setExpand={setExpand}
        lines={10}
        variant="list"
      >
        <ul>
          {conclusion.map((el, index) => (
            <li key={index}>
              <ScientificText>{el}</ScientificText>
            </li>
          ))}
        </ul>
      </ExpandableText>
    </section>
  );
}
